export enum OrderType {
  RETURN           = 'RETURN',
  ISSUE            = 'ISSUE',
  STO              = 'STO',
  MANAGED_RECOVERY = 'MANAGED_RECOVERY',
}
